// localization
import { defineMessages } from 'react-intl';

const controlsList = [{
  name: 'name',
  labelId: 'HEADER_TEXT',
  type: 'text',
  default: 'Header Item',
}, {
  name: 'fontSize',
  labelId: 'FONT_SIZE',
  type: 'slider',
  default: 24,
  options: {
    min: 16,
    max: 34,
    step: 1,
  },
}];

const messages = defineMessages({
  FONT_SIZE: {
    id: 'FONT_SIZE',
    defaultMessage: 'Font Size',
  },
  HEADER_TEXT: {
    id: 'HEADER_TEXT',
    defaultMessage: 'Header Text',
  },
});

function HeaderStyleControls({ renderControlItem }) {
  return controlsList.map(
    (controlItem, ciIndex) => renderControlItem(controlItem, messages[controlItem.labelId], ciIndex),
  );
}

export default HeaderStyleControls;
